import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { localStorage as storage } from "@/lib/localStorage";

// Pre-boot auto-seed: ensure data exists before rendering
try {
  const url = new URL(window.location.href);
  const forceSeed = url.searchParams.get("seed") === "1" || url.hash.includes("seed");
  const existingRaw = window.localStorage.getItem("cm:v1");
  const autoSeedFlag = window.localStorage.getItem("cm:autoseed");

  let shouldSeed = forceSeed;

  if (!shouldSeed) {
    if (!existingRaw) {
      shouldSeed = true;
    } else {
      try {
        const existing = JSON.parse(existingRaw);
        const emptyTypes = Array.isArray(existing?.types) ? existing.types.length === 0 : true;
        const emptyCodes = Array.isArray(existing?.codes) ? existing.codes.length === 0 : true;
        if (emptyTypes && emptyCodes) {
          shouldSeed = true;
        }
      } catch {
        shouldSeed = true;
      }
    }
  }

  if (shouldSeed) {
    storage.reset();
    storage.seedData();
    window.localStorage.setItem("cm:autoseed", "1");
  }
} catch (e) {
  console.error("Pre-boot auto-seed failed:", e);
}

createRoot(document.getElementById("root")!).render(<App />);
